import React, { useState, useEffect } from 'react';

import ProductCard from '../components/ProductCard';
import Pagination from '../components/Pagination';
import { supabase } from '../supabaseClient'; // Asegúrate de tenerlo configurado

const SearchPage = ({ searchTerm, onAddToCart, onProductClick }) => {
  const [allProducts, setAllProducts] = useState([]);
  const [results, setResults] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage, setProductsPerPage] = useState(10);
const fallbackTerm = decodeURIComponent(window.location.pathname.replace('/search/', '').trim());
const termToSearch = searchTerm || (fallbackTerm !== 'search' ? fallbackTerm : '');

  // Cargar todos los productos desde Supabase
  useEffect(() => {
    const fetchProducts = async () => {
      const { data, error } = await supabase.from('products').select('*');
      if (error) {
        console.error('Error al obtener productos:', error.message);
      } else {
        setAllProducts(data || []);
      }
    };

    fetchProducts();
  }, []);

  // Filtrar los productos al cambiar el término de búsqueda
  useEffect(() => {
    if (searchTerm && searchTerm.trim() !== '') {
      const lowerCaseSearchTerm = searchTerm.trim().toLowerCase();
      const filtered = allProducts.filter(product =>
        (product.name && product.name.toLowerCase().includes(lowerCaseSearchTerm)) ||
        (product.description && product.description.toLowerCase().includes(lowerCaseSearchTerm)) ||
        (product.category && product.category.toLowerCase().includes(lowerCaseSearchTerm)) ||
        (product.sku && product.sku.toLowerCase() === lowerCaseSearchTerm)
      );
      setResults(filtered);
      setCurrentPage(1);
    } else {
      setResults([]);
    }
  }, [searchTerm, allProducts]);

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = results.slice(indexOfFirstProduct, indexOfLastProduct);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <h5 className="text-1xl sm:text-2xl font-extrabold text-gray-900 mb-6 sm:mb-10 text-center">
        {searchTerm && searchTerm.trim() !== '' ? `Mostrando resultados para "${searchTerm}"` : "Ingresa un término para buscar"}
      </h5>

      {searchTerm && searchTerm.trim() !== '' && currentProducts.length > 0 && (
        <div className="flex justify-end items-center mb-6">
          <label htmlFor="productsPerPage" className="text-gray-700 mr-2">Mostrar:</label>
          <select
            id="productsPerPage"
            value={productsPerPage}
            onChange={(e) => setProductsPerPage(Number(e.target.value))}
            className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#5A61E5]"
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value={results.length}>Todos</option>
          </select>
        </div>
      )}

      {searchTerm && searchTerm.trim() !== '' ? (
        currentProducts.length === 0 ? (
          <p className="text-gray-600 text-lg text-center py-8">No se encontraron productos que coincidan con tu búsqueda.</p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-4 sm:gap-6">
            {currentProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onAddToCart={onAddToCart}
                onProductClick={onProductClick}
              />
            ))}
          </div>
        )
      ) : (
        <p className="text-gray-600 text-lg text-center py-8">Escribe algo en la barra de búsqueda para encontrar productos.</p>
      )}

      {searchTerm && searchTerm.trim() !== '' && results.length > productsPerPage && (
        <Pagination
          productsPerPage={productsPerPage}
          totalProducts={results.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      )}
    </div>
  );
};

export default SearchPage;
